function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

var _class;

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  Object.defineProperty(subClass, "prototype", {
    value: Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    }),
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

import React from 'react';
import { $attrs } from "../sui/bind";
import classnames from 'classnames';
import createFormComponent from '../sui/createFormComponent';
import './index.css';

var Editor = require('./editor/js/wangEditor');
/**
 * 富文本框控件
 */


var SuiEditor = createFormComponent(_class = /*#__PURE__*/function (_React$Component) {
  _inherits(SuiEditor, _React$Component);

  var _super = _createSuper(SuiEditor);

  function SuiEditor(props, context) {
    var _this2;

    _classCallCheck(this, SuiEditor);

    _this2 = _super.call(this, props);
    _this2.editor = void 0;
    _this2.pageData = {
      labelId: "wangEditor" + new Date().getTime() + parseInt(Math.random() * 1000),
      wordNum: function () {
        return _this2.editor ? _this2.editor.$txt.formatText().length : 0;
      }()
    };
    _this2.defaultValue = "";

    _this2.shouldComponentUpdateFilter = function (needUpdate, nextProps, nextState) {
      return needUpdate;
    };

    _this2.getRefDOM = function (node) {
      if (node && _this2.refDOM !== node) {
        _this2.refDOM = node;
      }

      return _this2.refDOM;
    };

    _this2.getRefInstance = function (node) {
      if (node && _this2.refInstance !== node) {
        _this2.refInstance = node;
      }

      return _this2.refInstance;
    };

    _this2.changeHandler = function (val) {
      _this2.changeValue(val);
    };

    _this2.po_Last_Div = function (obj) {
      var range;

      if (window.getSelection) {
        //ie11 10 9 ff safari
        obj.focus(); //解决ff不获取焦点无法定位问题

        range = window.getSelection(); //创建range

        range.selectAllChildren(obj); //range 选择obj下所有子内容

        range.collapseToEnd(); //光标移至最后
      } else if (document.selection) {
        //ie10 9 8 7 6 5
        range = document.selection.createRange(); //创建选择对象
        //var range = document.body.createTextRange();

        range.moveToElementText(obj); //range定位到obj

        range.collapse(false); //光标移至最后

        range.select();
      }
    };

    _this2.onFocus = function () {
      var _this = _assertThisInitialized(_this2);

      setTimeout(function () {
        _this.wordNumVerify();
      }, 0);
    };

    _this2.onBlur = function () {
      _this2.wordNumVerify();
    };

    _this2.wordNumVerify = function () {
      _this2.setWordNum();

      var iserror = false;
      var infoshow = false;
      var infoText = "";

      if (_this2.props.isWordNum || _this2.props.maxWord || _this2.props.maxWord < _this2.attrs.wordNum || _this2.refInstance !== document.activeElement && _this2.props.required && _this2.attrs.wordNum === 0) {
        infoshow = true;

        if (_this2.refInstance !== document.activeElement && _this2.props.required && _this2.attrs.wordNum === 0) {
          iserror = true;
          infoText = "对不起，此项为必填项";
        } else {
          if (_this2.props.maxWord < _this2.attrs.wordNum) {
            iserror = true;
            infoText = "对不起，您输入的字符数已超上线";
          } else {
            iserror = false;

            if (_this2.props.maxWord) {
              infoText = "\u5DF2\u8F93\u5165".concat(_this2.attrs.wordNum, "\u4E2A\u5B57\u7B26\uFF0C\u8FD8\u53EF\u4EE5\u8F93\u5165").concat(_this2.props.maxWord - _this2.attrs.wordNum, "\u4E2A\u5B57\u7B26\u3002");
            } else {
              infoText = "\u5DF2\u8F93\u5165".concat(_this2.attrs.wordNum, "\u4E2A\u5B57\u7B26\u3002");
            }
          }
        }
      } else {
        infoshow = false;
      }

      _this2.attrs.iserror = iserror;
      _this2.attrs.infoshow = infoshow;
      _this2.attrs.infoText = infoText;
    };

    _this2.setWordNum = function () {
      if (_this2.editor) {
        _this2.attrs.wordNum = _this2.editor.$txt.formatText().length;
      }
    };

    var _props$defaultValue = props.defaultValue,
        defaultValue = _props$defaultValue === void 0 ? "" : _props$defaultValue;
    _this2.attrs = $attrs({
      readOnly: false,
      disabled: false,
      iserror: false,
      wordNum: 0,
      infoText: "",
      infoshow: false,
      value: defaultValue
    });

    _this2.attrs.$sui.attach(props, _assertThisInitialized(_this2), context);

    return _this2;
  }

  _createClass(SuiEditor, [{
    key: "getValue",
    value: function getValue(html) {
      if (!html) {
        return this.editor.$txt.text();
      }

      var val = this.editor.$txt.html();
      return val === '<p><br></p>' ? "" : val;
    }
  }, {
    key: "setValue",
    value: function setValue(val) {
      this.setHTML(val);
    } // 获取组件实例

  }, {
    key: "changeValue",
    value: function changeValue(val) {
      this.wordNumVerify();
      this.attrs.value = val;

      if (this.props.onChange) {
        this.props.onChange.call(this, val);
      }
    } //光标定位 放到最后面 contenteditable h5新特性

  }, {
    key: "doRender",
    value: function doRender() {
      console.log('editor render => ', this.props.value);
      var _this$attrs = this.attrs,
          $sui = _this$attrs.$sui,
          iserror = _this$attrs.iserror;
      var _$sui$restProps = $sui.restProps,
          _$sui$restProps$id = _$sui$restProps.id,
          id = _$sui$restProps$id === void 0 ? this.uuid : _$sui$restProps$id,
          _$sui$restProps$label = _$sui$restProps.labelId,
          labelId = _$sui$restProps$label === void 0 ? this.pageData.labelId : _$sui$restProps$label,
          componentStyle = _$sui$restProps.componentStyle;
      var classNames = classnames("sui-component sui-editor", {
        'has-error': iserror
      });
      var style = {};

      if (this.props.width) {
        style.width = this.props.width + 'px';
      }

      if (this.props.height) {
        style.height = this.props.height + 'px';
      }

      if (this.props.maxHeight) {
        style.maxHeight = this.props.maxHeight + 'px';
      }

      return /*#__PURE__*/React.createElement("div", {
        style: componentStyle,
        id: id,
        className: classNames,
        ref: this.getRefDOM
      }, /*#__PURE__*/React.createElement("div", {
        id: labelId,
        style: style,
        ref: this.getRefInstance,
        onBlur: this.onBlur,
        onFocus: this.onFocus
      }), this.attrs.infoshow ? /*#__PURE__*/React.createElement(Text, {
        info: this.attrs.infoText
      }) : null);
    }
  }, {
    key: "render",
    value: function render() {
      return this.doRender();
    }
  }, {
    key: "setHTML",
    value: function setHTML(val) {
      var value = "" + val;
      this.editor && this.editor.$txt.html(value || '<p><br></p>');
    }
  }, {
    key: "getEditor",
    value: function getEditor() {
      return this.editor;
    }
  }, {
    key: "createEditor",
    value: function createEditor() {
      var _this = this;

      var domId = this.attrs.$sui.restProps.labelId || this.pageData.labelId;
      var menus = [['bold', 'underline', 'italic', 'strikethrough', 'eraser', 'forecolor', 'bgcolor'], ['quote', 'fontfamily', 'fontsize', 'head', 'unorderlist', 'orderlist', 'alignleft', 'aligncenter', 'alignright'], ['link', 'unlink', 'table', 'emotion'], ['img', 'video', 'location', 'insertcode', 'undo', 'redo'], ['source', 'fullscreen']];
      var menu = menus[0];
      var menuProp = this.props.menu || 'simple';

      if (menuProp === 'normal') {
        menu = menu.concat(['|'], menus[1], ['|'], menus[2]);
      } else if (menuProp === "full") {
        menu = menu.concat(['|'], menus[1], ['|'], menus[2], ['|'], menus[3], ['|'], menus[4]);
      }

      if (this.props.sourceCode || this.props.fullscreen) {
        menu.push('|');

        if (this.props.sourceCode) {
          menu.push('source');
        }

        if (this.props.fullscreen) {
          menu.push('fullscreen');
        }
      }

      this.editor = new Editor(domId);
      this.editor.config.menus = menu;
      this.editor.config.printLog = false;
      this.editor.config.height = (this.props.height || 120) + 'px';

      if (this.props.resetConfig) {
        this.props.resetConfig(this.editor.config);
      }

      this.editor.create(); //將editor对象返回给父组件

      this.props.onEditorCreate && this.props.onEditorCreate(this.editor);
      this.setHTML(this.attrs.value);

      this.editor.onchange = function () {
        var val = _this.getValue();

        _this.changeHandler(val);
      };

      setTimeout(function () {
        if (_this.refInstance === document.activeElement) {
          _this.po_Last_Div(_this.refInstance);
        }
      }, 0);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.createEditor();
    }
  }]);

  return SuiEditor;
}(React.Component)) || _class;

var Text = /*#__PURE__*/function (_React$Component2) {
  _inherits(Text, _React$Component2);

  var _super2 = _createSuper(Text);

  function Text(props, context) {
    var _this3;

    _classCallCheck(this, Text);

    _this3 = _super2.call(this, props, context);
    _this3.state = {};
    return _this3;
  }

  _createClass(Text, [{
    key: "doRender",
    value: function doRender() {
      var text = this.props.info || "";
      return text ? /*#__PURE__*/React.createElement("p", {
        className: "contentText"
      }, text) : null;
    }
  }, {
    key: "render",
    value: function render() {
      return this.doRender();
    }
  }]);

  return Text;
}(React.Component);

export default SuiEditor;